const withFreshAudio = async (track) => {
  if (!track || !track.id) {
    return track;
  }

  try {
    const { data } = await axios.get(`/api/mmn/song/${track.id}/audio`);

    if (data && data.audio) {
      return {
        ...track,
        audio: data.audio,
        audio_type: data.audio_type,
      };
    }
  } catch (error) {
    console.error('Unable to refresh song audio url', error);
  }

  return track;
};

export default {
  player: (context, player) => {
    context.commit('SET_PLAYER', player);
  },
  play: (context) => {
    context.commit('PLAY');
  },
  pause: (context) => {
    context.commit('PAUSE');
  },
  setPlayerCurrentTime: (context, time) => {
    context.commit('SET_PLAYER_CURRENT_TIME', time);
  },
  setPlayerDuration: (context, time) => {
    context.commit('SET_PLAYER_DURATION', time);
  },
  setPlayerTracks: (context, tracks) => {
    context.commit('SET_PLAYER_TRACKS', tracks);
  },
  setShuffleTracks: (context, shuffleTracks) => {
    context.commit('SET_SHUFFLE_TRACKS', shuffleTracks);
  },
  setOriginalTracks: (context) => {
    context.commit('SET_ORIGINAL_TRACKS');
  },
  setPlayerCurrentTrack: async (context, track) => {
    axios.post(`/api/mmn/song-play/${track.id}`).catch(() => {});
    const updatedTrack = await withFreshAudio(track);
    context.commit('SET_PLAYER_CURRENT_TRACK', updatedTrack);
  },
  setPlayerSeeking: (context, track) => {
    context.commit('SET_PLAYER_SEEKING', track);
  },
  refreshPlayerCurrentTrackAudio: async ({ state, commit }) => {
    if (!state.playerCurrentTrack) {
      return null;
    }

    const updatedTrack = await withFreshAudio(state.playerCurrentTrack);
    commit('SET_PLAYER_CURRENT_TRACK', updatedTrack);
    return updatedTrack;
  },
};
